import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PageDefault } from '../common/components/layouts/Page/PageDefault';
import { ErgoOfficeForm } from '../common/components/ErgoOfficeForm/ErgoOfficeForm';
import { ergoOfficesActions } from '../redux/ergoOffices/actions';
import Can from '../roleBasedAccess/Can';
import { PrimaryButton } from '../common/components/Buttons';

const ErgoOfficeEdit = ({
  match: {
    params: { ergoOfficeId },
  },
  error,
  pending,
  deletePending,
  ergoOffice,
  getErgoOffice,
  updateErgoOffice,
  deleteErgoOffice,
}) => {
  useEffect(() => {
    getErgoOffice(ergoOfficeId);
  }, [ergoOfficeId, getErgoOffice]);

  const onSubmit = newErgoOfficeValues => {
    updateErgoOffice(ergoOfficeId, newErgoOfficeValues);
  };

  const onDeleteErgoOffice = () => {
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(
      `Voulez-vous supprimer le cabinet n°${ergoOffice.id} - ${ergoOffice.name} ?`,
    );
    if (confirm) deleteErgoOffice(ergoOfficeId);
  };

  return (
    <PageDefault
      title="Edition de la fiche cabinet"
      pageAction={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <Can
          perform="delete"
          yes={() => (
            <PrimaryButton
              isLoading={deletePending}
              loadingText="En supression..."
              onClick={onDeleteErgoOffice}
            >
              Supprimer
            </PrimaryButton>
          )}
        />
      }
    >
      <ErgoOfficeForm
        initialValues={ergoOffice}
        pending={pending}
        onSubmit={onSubmit}
        error={error}
        mode="edit"
      />
    </PageDefault>
  );
};

const mapStateToProps = ({ ergoOffices: state }) => ({
  ergoOffice: state.ergoOffice,
  error: state.error,
  pending: state.pending,
  deletePending: state.deletePending,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateErgoOffice: ergoOfficesActions.updateErgoOffice,
      getErgoOffice: ergoOfficesActions.getErgoOffice,
      deleteErgoOffice: ergoOfficesActions.deleteErgoOffice,
    },
    dispatch,
  );

ErgoOfficeEdit.propTypes = {
  pending: PropTypes.bool,
  deletePending: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.object,
  updateErgoOffice: PropTypes.func.isRequired,
  getErgoOffice: PropTypes.func.isRequired,
};

ErgoOfficeEdit.defaultProps = {
  pending: false,
  deletePending: false,
  error: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(ErgoOfficeEdit);
